import { render } from "./EmpresaView.vue?vue&type=template&id=18ef7d01"
import script from "./EmpresaView.vue?vue&type=script&lang=js"
export * from "./EmpresaView.vue?vue&type=script&lang=js"

import "./EmpresaView.vue?vue&type=style&index=0&id=18ef7d01&lang=scss"

import exportComponent from "/home/runner/work/topnetms/topnetms/apps/topnetms_site_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__